import {
    SET_CONDITION,
} from "./ConditionType";

const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_CONDITION:
            return {
                ...state,
                conditionDropDown: action.conditionDropDown,
            };
        default:
            return state;
    }
};

export default reducer;
